import {ErrorHandler, Inject, Injectable, Injector} from '@angular/core';
import { LogService } from '../log/log.service';
import {fromError} from 'stacktrace-js';
import {HttpErrorResponse} from '@angular/common/http';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
    constructor(@Inject(Injector) private injector: Injector) {
        super();
    }

    private get logService(): LogService {
        return this.injector.get(LogService);
    }

    public handleError(error) {
        if (error instanceof HttpErrorResponse) {
            return;
        }

        const message = error.message ? error.message : error.toString();

        if (error.status) {
            error = new Error(`${error.status} - ${error.message}`);
        }

        fromError(error).then((stackFrames) => {
            const stackString = stackFrames
                .splice(0, 10)
                .map(function (sf) {
                    return sf.toString();
                })
                .join('\n');

            const errorTraceStr = `Error message: ${message}. \nStack trace: ${stackString}`;

            this.logService.logFatal(errorTraceStr);

            throw error;
        });
    }
}
